import { getConfig } from './runtimeConfig';

// All properties are resolved lazily at access time.
// Safe to use after loadRuntimeConfig() has completed in App.tsx init().
export const CONFIG = {
  get graphqlUrl()     { return getConfig().graphqlUrl; },
  get cognitoDomain()  { return getConfig().cognitoDomain; },
  get clientId()       { return getConfig().clientId; },
  get wsUrl()          { return getConfig().wsUrl; },
  get redirectUri()    { return getConfig().redirectUri; },
  get requiredGroup()  { return getConfig().requiredGroup; },
  get applicationId()  { return getConfig().applicationId; },
  get environment()    { return getConfig().environment; },
  get tenantId()       { return getConfig().tenantId ?? 'tenant-Elevations'; },
  get gazetteerUrl()   { return getConfig().gazetteerUrl; },
  get basemapUrl()     { return getConfig().basemapUrl; },
} as const;
